import { RouterUtilsImpl } from '../../../utils/RouterUtils';

const routerUtils = new RouterUtilsImpl();

export class NavigationHelper {
  public static getResultsUrl(guid: string): string {
    return routerUtils.getRoute('PublicSurveyResults', guid);
  }

  public static getActionPlanUrl(guid: string): string {
    return routerUtils.getRoute('PublicSurveyActionPlan', guid);
  }

  public static isActionPlanRoute(pathname: string): boolean {
    return pathname.endsWith('/action-plan');
  }
}
